import { PermissionValues as Permissions, WorkspaceType } from '@gripp/shared-logic';
import { CampaignsPage } from './components/campaignsPage';
import { CampaignsToolbar } from './components/campaignsToolbar';

export const campaignsPaths = {
  root: 'campaigns',
} as const;

export const campaignsRoutes = [
  {
    path: `${campaignsPaths.root}/*`,
    element: <CampaignsPage />,
    handle: {
      header: {
        titleKey: 'campaigns.page.title',
        icon: 'bullhorn',
      },
      requiredPermission: Permissions.campaign.read,
      requiredWorkspaceType: WorkspaceType.Oem,
      toolbar: <CampaignsToolbar />,
    },
  },
];
